import { useRecoilValue } from 'recoil';
import { widgetStateAtom } from '../../../shared/state/widgetStateAtom';
import { defaultGroupId } from '../../../shared/types/widgetGroup';

export const useWidgetGroup = (groupId?: number) => {
  const widgetState = useRecoilValue(widgetStateAtom);

  return widgetState.groups[groupId || defaultGroupId];
};
